import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconActiveProps, IconRender } from '../types.ts';

const More = React.forwardRef<SVGSVGElement | null, IconActiveProps>(function More({ active, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5 14C6.10457 14 7 13.1046 7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12Z'
          fill={active ? 'transparent' : color}
        />
        {/* active */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z'
          fill={active ? color : 'transparent'}
        />
      </>
    ),
    [active],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'more-icon-svg'} iconRender={iconRender} {...props} />;
});

export default More;
